/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { TaskCatalogEntry } from './TaskCatalogEntry';
import {
    TaskCatalogEntryFromJSON,
    TaskCatalogEntryFromJSONTyped,
    TaskCatalogEntryToJSON,
    instanceOfTaskCatalogEntry,
} from './TaskCatalogEntry';

/**
 * Catalog entries grouped by experience.
 * @export
 * @interface ExperienceTaskCatalog
 */
export interface ExperienceTaskCatalog {
    /**
     * Unique identifier assigned to the experience.
     * @type {string}
     * @memberof ExperienceTaskCatalog
     */
    experienceId: string;
    /**
     * Human-readable display name for the experience.
     * @type {string}
     * @memberof ExperienceTaskCatalog
     */
    experienceName: string;
    /**
     * Optional assets representing the experience.
     * @type {Array<string>}
     * @memberof ExperienceTaskCatalog
     */
    assetIds?: Array<string>;
    /**
     * Tasks made available by this experience.
     * @type {Array<TaskCatalogEntry>}
     * @memberof ExperienceTaskCatalog
     */
    catalogEntries: Array<TaskCatalogEntry>;
}


/**
 * Check if a given object implements the ExperienceTaskCatalog interface.
 */
export function instanceOfExperienceTaskCatalog(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "experienceId" in value;
    isInstance = isInstance && "experienceName" in value;
    isInstance = isInstance && "catalogEntries" in value;
    return isInstance;
}

export function ExperienceTaskCatalogFromJSON(json: any): ExperienceTaskCatalog {
    return ExperienceTaskCatalogFromJSONTyped(json, false);
}

export function ExperienceTaskCatalogFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperienceTaskCatalog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'experienceId': json['experienceId'],
        'experienceName': json['experienceName'],
        'assetIds': !exists(json, 'assetIds') ? undefined : json['assetIds'],
        'catalogEntries': ((json['catalogEntries'] as Array<any>).map(TaskCatalogEntryFromJSON)),
    };
}

export function ExperienceTaskCatalogToJSON(value?: ExperienceTaskCatalog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'experienceId': value.experienceId,
        'experienceName': value.experienceName,
        'assetIds': value.assetIds === undefined ? undefined : value.assetIds,
        'catalogEntries': ((value.catalogEntries as Array<any>).map(TaskCatalogEntryToJSON)),
    };
}

